/* eslint-disable max-len */
import Swiper, { Pagination, Autoplay } from 'swiper';

/* eslint-disable no-unused-vars */
const qcSwiper = new Swiper('.hh-swiper', {
  modules: [Pagination, Autoplay],
  loop: true,
  pagination: {
    el: '.hh-swiper-pagination',
    clickable: true,
    type: 'bullets',
  },
  autoplay: true,
});
